import isoFetch from 'isomorphic-fetch';
import { debug } from '../../utils';

import { localUrl } from '../utils';

const log = debug('lego:api/index');

export function checkStatus(response) {
 return response;
}

const jsonOpts = (method, Cookie, data?) => {
    return {
        method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Cookie
        },
        body: JSON.stringify(data)
    }
};

const fetchUrl = (url, opts) => {
    //log(url, opts);
    const fullUrl = url.indexOf('//') > -1 ? url : `${localUrl}/${url}`;
 return isoFetch(fullUrl, opts)
        .then(checkStatus)
        .then((res) => res.json())
        .catch((error) => {
            log(`FAILED: ${opts.method}: ${url} body: ${opts.body}\n`)
            throw error;
        });
};

const getJSON = (url, query=undefined, cookie) => fetchUrl(url, jsonOpts('GET', cookie, query));
const postJSON = (url, data, cookie) => fetchUrl(url, jsonOpts('POST', cookie, data));

export const fetch = {
  url: fetchUrl
};

export const json = {
  get: getJSON,
  post: postJSON
};



// WEBPACK FOOTER //
// ./src/app/utils/fetch.ts